import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { chooseClipart, deleteUserArt } from "../../actions";
import ImagesList from "./ImagesList";
import Tabs from "../Layout/Tabs";
import Tab from "../Layout/Tabs/Tab";
import ConfirmDelete from "./ConfirmDelete";
import Deleting from "./Deleting";
import "./UserArt.css";
import Dialog from "../Dialog";
import localStorageWrapper from "../../services/localStorageWrapper";

class UserArt extends React.Component {
  state = {
    dialogVisible: false,
    idToDelete: null,
    visible: true,
    showDialog: false,
    photoLayers: 0,
  };

  componentDidMount() {
    this.dialog = {
      title: "Designer's Tip",
      message:
        "Click on your graphic then click and drag on circle in the lower right corner to adjust the size.",
      topPosition: 100,
      leftPosition: 100,
      origin: "bottomright",
    };

    // Expiration for local storage
    this.userArtTimestamp = Date.now();
    const expires = 60 * 60 * 1000 * 24;

    // Delete local storage after 24 hours
    if (
      this.userArtTimestamp -
        localStorageWrapper.getItem("fypUserArtDialogShownTimestamp") >
      expires
    ) {
      localStorageWrapper.removeItem("fypUserArtDialogShown");
      localStorageWrapper.removeItem("fypUserArtDialogShownTimestamp");
    }
  }

  onShowDialog = () => {
    if (
      !this.state.showDialog &&
      !localStorageWrapper.getItem("fypUserArtDialogShown")
    ) {
      this.setState({
        showDialog: true,
      });

      this.setLocalStorage();
    }
  };

  handleHideDialog = () => {
    this.setState({
      showDialog: false,
    });
  };

  setLocalStorage = () => {
    // Set local storage for 24 hours to remember that the tips have been shown
    localStorageWrapper.setItem("fypUserArtDialogShown", true);
    localStorageWrapper.setItem(
      "fypUserArtDialogShownTimestamp",
      this.userArtTimestamp,
    );
  };

  handleChooseArt = (payload) => {
    let designId = this.props.design.product_type_id
    payload.limits = this.props.clipartLimits[designId];

    this.props.chooseClipart(payload)
    this.onShowDialog()
  }

  onDelete = (id) => {
    this.setState({
      dialogVisible: true,
      idToDelete: id,
    });
  };

  handleDelete = (id) => {
    this.props.deleteUserArt(id);

    this.setState({
      dialogVisible: false,
    });
  };

  handleCancelDelete = () => {
    this.setState({
      dialogVisible: false,
      idToDelete: null,
    });
  };

  render() {
    const design = this.props.design,
      layers = design.layer_set,
      imageType = this.props.imageType;

    // Filter layers that allow images (Limit to one layer due to supporting multiple images on a single layer)
    let layersWithImages = layers.filter((obj) => {
      return imageType === "photo" ? obj.photo_image : obj.allow_image;
    });

    // Check if layers are stacked and second upload image layer should be hidden
    let top_position, left_position = 0;
    let layersStacked = true;
    layersWithImages.forEach(function (layer, index) {
      if ((top_position > 0 && left_position > 0) && (top_position != layer.top_position || left_position != layer.left_position)){
        layersStacked = false;
      }
      top_position = layer.top_position;
      left_position = layer.left_position;
    });

    if (this.props.imageType == 'photo' && layersStacked && layersWithImages.length > 0){
      layersWithImages = [layersWithImages[0]];
    }

    // Number of image layers
    const layersWithImagesCount = layersWithImages.length,
      tabsNavArray = [];

    const layerImageList = layersWithImages.map((layer, index) => {
      tabsNavArray.push({
        name: layer.image_collection_name,
        layer_id: layer.layer_id,
      });

      const selectedImageType =
        layer.image_elements.length > 0
          ? layer.image_elements[0].type
          : "clipart";
      const selectedId =
        layer.image_elements.length > 0 && layer.image_elements[0].userart
          ? layer.image_elements[0].userart.id
          : null;

      if (layersWithImagesCount > 1) {
        return (
          <Tab key={layer.layer_id} id={index}>
            <ImagesList
              className={this.state.visibility}
              key={layer.layer_id}
              layerId={layer.layer_id}
              userArt={this.props.user_art}
              imageType={this.props.imageType}
              selectedImageType={selectedImageType}
              selectedId={selectedId}
              handleChooseArt={this.handleChooseArt}
              onDelete={this.onDelete}
              idToDelete={this.state.idToDelete}
            />
          </Tab>
        );
      } else {
        return (
          <ImagesList
            key={layer.layer_id}
            layerId={layer.layer_id}
            userArt={this.props.user_art}
            imageType={this.props.imageType}
            selectedImageType={selectedImageType}
            selectedId={selectedId}
            handleChooseArt={this.handleChooseArt}
            onDelete={this.onDelete}
            idToDelete={this.state.idToDelete}
          />
        );
      }
    });

    let layerImagesWrapper = (
      <div className="art--single-layer">{layerImageList}</div>
    );

    if (layersWithImagesCount > 1) {
      // Wrap in Tabs component if more than 1 layer supports text
      layerImagesWrapper = (
        <Tabs tabsNavArray={tabsNavArray}>{layerImageList}</Tabs>
      );
    }

    return (
      <div className="tool tool--user-art user-art">
        {this.state.showDialog && this.dialog && (
          <Dialog dialog={this.dialog} onHideDialog={this.handleHideDialog} />
        )}
        <div className="tool__options">{layerImagesWrapper}</div>

        {this.props.deleting && <Deleting />}

        <ConfirmDelete
          visibility={this.state.dialogVisible}
          id={this.state.idToDelete}
          handleDelete={this.handleDelete}
          handleCancelDelete={this.handleCancelDelete}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clipartLimits: state.clipart.limits,
    clipartCategories: state.clipart.categories,
    user_art: state.upload.user_art.entities,
    design: state.design.present,
    deleting: state.deletingUserArt.deleting,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      chooseClipart,
      deleteUserArt: deleteUserArt.request,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserArt);
